import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Link, useNavigate, useLocation } from "react-router-dom"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from "reactstrap"

import useIdle from "components/Hooks/useIdleTimer"

import {
  setSessionExpire,
  getSessionExpire,
  getSessionTimeout,
} from "../../helpers/AuthType/authService"

import {
  getCurrentTime,
  fnDateTimePlus,
  fnGetDateDiff,
  fnGetDateTime,
  dateTimeformat,
} from "common/global/functions.js"

import { useCountdown } from "components/Hooks/useCountdown"

const SessionTimeOut = props => {
  const navigate = useNavigate()

  const [sessionTimeoutModal, setSessionTimeoutModal] = useState(false)
  const [sessionTimeout, setSessionTimeout] = useState(getSessionTimeout())
  const [currentTime, setCurrentTime] = useState(getCurrentTime())
  const [timer, setTimer] = useState("01:00")
  const [remainingTime, setRemainingTime] = useState(null)

  const onPromptIdle = () => setSessionTimeoutModal(true)

  const logout = () => navigate("/session-timeout")

  const { getRemainingTime, getLastActiveTime, isIdle, activate } = useIdle({
    onIdle: logout,
    onPromptIdle,
    idleTime: 1800000, //process.env.REACT_APP_SESSIONEXPIRE, //miliseconds before expiration (30 minutes)
    promptTime: 120000, //process.env.REACT_APP_SESSIONPROMPT, //miliseconds before prompt (2 minutes)
  })

  const reset = () => {
    activate()
    setSessionTimeoutModal(false)
  }

  const sessionexpire = fnDateTimePlus(getCurrentTime(), {
    milliseconds: getRemainingTime ? getRemainingTime() : 0,
  }).toFormat(dateTimeformat)

  const { total, days, hours, minutes, seconds } = useCountdown(sessionexpire)

  useEffect(() => {
    if (total > 0) {
      setTimer(
        (minutes > 9 ? minutes : "0" + minutes) +
          ":" +
          (seconds > 9 ? seconds : "0" + seconds)
      )
    } else {
      setTimer("00:00")
    }
    //console.log({ timer, total })
  }, [total])
  return (
    <React.Fragment>
      {/* session timeout ModalHeader */}
      <Modal
        isOpen={sessionTimeoutModal}
        toggle={() => {
          //tog_backdrop();
        }}
        backdrop={"static"}
        id="staticBackdrop"
      >
        {/* <div className="modal-header">
          <h5 className="modal-title" id="staticBackdropLabel">
            Session Expiration
          </h5>
        </div> */}
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="avatar-md mx-auto mb-4">
              <div className="avatar-title bg-light  rounded-circle text-warning h1">
                <i className="mdi mdi-alert"></i>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-xl-10">
                <h4 className="text-warning">Session Expiration</h4>
                <p className="text-muted font-size-14 mb-4">
                  Your session will expire in: {timer}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => {
              logout()
            }}
          >
            Logout
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              reset()
            }}
          >
            Continue Working....
          </button>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default SessionTimeOut
